import * as React from "react"
import type { SVGProps } from "react"
const SvgDevicesDesktopMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.5 20.57q-.63 0-1.06-.44A1.5 1.5 0 0 1 2 19.07q0-.63.44-1.06a1.5 1.5 0 0 1 1.06-.44H4v-11q0-.82.59-1.41A2 2 0 0 1 6 4.57h14q.42 0 .71.29.3.29.29.71 0 .42-.29.71a1 1 0 0 1-.71.29H6v11h4.5q.63 0 1.06.44.45.43.44 1.06 0 .63-.44 1.06a1.5 1.5 0 0 1-1.06.44zm11.5 0a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.7v-10q0-.44.29-.72a1 1 0 0 1 .71-.29h6q.42 0 .71.29.3.29.29.71v10q0 .42-.29.71a1 1 0 0 1-.71.29zm1-3h4v-7h-4z" />
  </svg>
)
export default SvgDevicesDesktopMobile
